import { render, staticRenderFns } from "./ViewGroupRecord.vue?vue&type=template&id=740862de&scoped=true"
import script from "./ViewGroupRecord.vue?vue&type=script&lang=js"
export * from "./ViewGroupRecord.vue?vue&type=script&lang=js"
import style0 from "./ViewGroupRecord.vue?vue&type=style&index=0&id=740862de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740862de",
  null
  
)

/* custom blocks */
import block0 from "./ViewGroupRecord.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports